export default __webpack_public_path__ + "static/media/preset_custom_presets.6e37a9de.jpg";